import React, { useState, useEffect } from "react"
import "../../Styles/MobileViewstyles.css" // Mobile-specific styles
import ReactModal from "react-modal"
import Notify from "../Componentslogic/Usenotifications" // For notifications
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import axios from "axios"
import UsefetchCollectionAdmin from "../Componentslogic/Usefetchcollection"
import { FaWhatsapp, FaEnvelope } from "react-icons/fa"
import { db } from "../../Firebase/config"
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore"
ReactModal.setAppElement("#root")

const MobileUsers = () => {
  const [searchQuery, setSearchQuery] = useState("")
  const [filteredUsers, setFilteredUsers] = useState([])
  const [UsersData, setallUsersData] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [emailSubject, setEmailSubject] = useState("")
  const [emailBody, setEmailBody] = useState("")
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false)
  const [whatsAppMessage, setWhatsAppMessage] = useState("")
  const [selectedPhone, setSelectedPhone] = useState("")

  const {
    data: users,
    loading,
    // eslint-disable-next-line
    currentPageUsers,
    nextPage,
    // eslint-disable-next-line
    previousPage,
    hasMore,
  } = UsefetchCollectionAdmin("users")

  const fetchAllReservations = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"))
      const allUsersData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setallUsersData(allUsersData)
    } catch (error) {
      console.error("Error fetching all reservations:", error)
    }
  }
  const handleSendWhatsApp = () => {
    if (!whatsAppMessage.trim()) {
      Notify("Please enter a message", "error") // Ensure message isn't empty
      return
    }

    const message = encodeURIComponent(whatsAppMessage)
    const phoneNumber = selectedPhone.replace(/\D/g, "") // Remove any non-numeric characters

    // Detect if user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    // Use WhatsApp Web on desktop, WhatsApp App on mobile
    const whatsappUrl = isMobile
      ? `https://api.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Mobile opens WhatsApp App
      : `https://web.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Desktop opens WhatsApp Web

    window.open(whatsappUrl, "_blank") // Opens in new tab
    setShowWhatsAppModal(false) // Close modal after sending
  }

  const handleOpenWhatsAppModal = (phone) => {
    setSelectedPhone(phone)
    setWhatsAppMessage("") // Reset message input
    setShowWhatsAppModal(true)
  }

  const handleCloseWhatsAppModal = () => {
    setShowWhatsAppModal(false)
  }

  useEffect(() => {
    // Fetch all reservations when the user starts typing a search query
    if (searchQuery && UsersData.length === 0) {
      fetchAllReservations()
    }
  }, [searchQuery, UsersData.length])

  useEffect(() => {
    const filtered = (searchQuery ? UsersData : users).map((user) => ({
      ...user,
      totalOrders: 0,
      mostOrderedItem: "Loading...", // Placeholder before fetching data
    }))
    setFilteredUsers(filtered)
  }, [searchQuery, users, UsersData])
  useEffect(() => {
    const fetchUserStats = async () => {
      const updatedUsers = await Promise.all(
        users.map(async (user) => {
          const { totalOrders, mostOrderedItem } = await getUserOrderData(
            user.phone || ""
          )
          const { totalReviews, above7Reviews, below7Reviews } =
            await getUserReviewStats(user.phone || "")

          return {
            ...user,
            totalOrders,
            mostOrderedItem,
            totalReviews,
            above7Reviews,
            below7Reviews,
          }
        })
      )
      setFilteredUsers(updatedUsers)
    }

    if (users.length > 0) {
      fetchUserStats()
    }
  }, [users, searchQuery])
  const getUserOrderData = async (phone) => {
    try {
      const ordersRef = collection(db, "Orders")
      const q = query(ordersRef, where("phone", "==", phone))
      const querySnapshot = await getDocs(q)

      let totalOrders = querySnapshot.size
      let itemCounts = {}

      querySnapshot.forEach((doc) => {
        const orderData = doc.data()
        orderData.cartItems?.forEach((item) => {
          const itemName = item.name || "Unknown"
          itemCounts[itemName] =
            (itemCounts[itemName] || 0) + item.CartTotalQuantity
        })
      })

      const mostOrderedItem = Object.entries(itemCounts).reduce(
        (max, item) => (item[1] > max[1] ? item : max),
        ["None", 0]
      )[0]

      return { totalOrders, mostOrderedItem }
    } catch (error) {
      console.error("Error fetching orders:", error)
      return { totalOrders: 0, mostOrderedItem: "N/A" }
    }
  }

  // ✅ Fetch total reviews and categorize them
  const getUserReviewStats = async (phone) => {
    try {
      const reviewsRef = collection(db, "Reviews")
      const q = query(reviewsRef, where("userPhone", "==", phone))
      const querySnapshot = await getDocs(q)

      let totalReviews = querySnapshot.size
      let above7Reviews = 0
      let below7Reviews = 0

      querySnapshot.forEach((doc) => {
        const review = doc.data()
        const totalScore =
          (review.ratingFood || 0) + (review.ratingService || 0)

        if (totalScore >= 7) {
          above7Reviews++
        } else {
          below7Reviews++
        }
      })

      return { totalReviews, above7Reviews, below7Reviews }
    } catch (error) {
      console.error("Error fetching reviews:", error)
      return { totalReviews: 0, above7Reviews: 0, below7Reviews: 0 }
    }
  }

  // Pagination: Show 2 user cards per page
  const itemsPerPage = 4
  const [currentPage, setCurrentPage] = useState(1)

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem)
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage)

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
  }

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1)
  }

  const handleExtract = () => {
    if (users.length > 0) {
      const usersData = users.map((user, index) => ({
        id: index + 1,
        "Client-Name": user.name,
        "Client-Email": user.email,
      }))
      const worksheet = XLSX.utils.json_to_sheet(usersData)
      worksheet["!cols"] = [{ wch: 10 }, { wch: 20 }, { wch: 40 }]
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users")
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" })
      saveAs(blob, "Users.xlsx")
      Notify("Extracted", "success")
    } else {
      Notify("An error occurred", "error")
    }
  }

  const handleOpenModal = (user) => {
    if (!user.email) {
      Notify("No email for this user", "error")
      return
    }
    setSelectedUser(user)
    setEmailSubject("")
    setEmailBody("")
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedUser(null)
  }

  const handleSendEmail = async () => {
    if (!emailSubject || !emailBody) {
      Notify("Please fill out all fields", "error")
      return
    }
    try {
      // Simulate sending email via API
      await axios.post("/api/send-custom-email", {
        name: selectedUser.name,
        email: selectedUser.email,
        subject: emailSubject,
        body: emailBody,
        senderName: "Team True Mama",
      })
      Notify("Email sent successfully", "success")
      handleCloseModal()
    } catch (error) {
      Notify("Failed to send email", "error")
    }
  }

  return (
    <div className="mobile-dashboard-container mt-3">
      <header className="mobile-users-header">
        <input
          type="text"
          placeholder="Search Users..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="mobile-search-input"
        />
      </header>

      <div className="pagination-controls mb-3">
        <span className="pagination-info">
          Page {currentPage} of {Math.ceil(filteredUsers.length / itemsPerPage)}
        </span>
        {currentPage > 1 && (
          <button
            className="pagination-btn"
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            &#8592;
          </button>
        )}

        {currentPage < Math.ceil(filteredUsers.length / itemsPerPage) && (
          <button
            className="pagination-btn"
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            &#8594;
          </button>
        )}
      </div>

      <section className="mobile-users-list">
        {currentUsers.map((user, index) => (
          <div key={index} className="mobile-review-card">
            <p>
              <strong>Name:</strong> {user.name}
            </p>
            <p>
              <strong>Email:</strong> {user.email || ""}
            </p>
            <p>
              <strong>Phone:</strong> {user.phone}
            </p>
            <p>
              <strong>Area:</strong> {user.area || ""}
            </p>
            <p>
              <strong>Total Orders:</strong> {user.totalOrders}
            </p>
            <p>
              <strong>Most Ordered:</strong> {user.mostOrderedItem}
            </p>

            <p>
              <strong>Good reviews:</strong> {user.above7Reviews}
            </p>
            <p>
              <strong>Bad Reviews:</strong> {user.below7Reviews}
            </p>

            <div className="mobile-user-actions">
              <FaWhatsapp
                size={24} // Adjust icon size
                color="green"
                className="whatsapp-icon mx-2"
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenWhatsAppModal(user.phone)}
              />
              <FaEnvelope
                size={24}
                color="blue"
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenModal(user)}
              />
            </div>
          </div>
        ))}
      </section>

      {/* Modal for Sending Email */}
      <ReactModal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Send Email to {selectedUser?.name}</h2>
        <div className="form-group mt-3">
          <label>Email:</label>
          <input
            type="text"
            className="form-control"
            value={selectedUser?.email || ""}
            disabled
          />
        </div>
        <div className="form-group mt-3">
          <label>Subject:</label>
          <input
            type="text"
            className="form-control"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>Message:</label>
          <textarea
            className="form-control"
            rows="5"
            value={emailBody}
            onChange={(e) => setEmailBody(e.target.value)}
          ></textarea>
        </div>
        <div className="modal-actions">
          <button className="modal-btn cancel" onClick={handleCloseModal}>
            Cancel
          </button>
          <button className="modal-btn send" onClick={handleSendEmail}>
            Send Email
          </button>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={showWhatsAppModal}
        onRequestClose={handleCloseWhatsAppModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Send WhatsApp Message</h2>

        <div className="form-group mt-3">
          <label>Phone Number:</label>
          <input
            type="text"
            className="form-control"
            value={selectedPhone}
            disabled
          />
        </div>

        <div className="form-group mt-3">
          <label>Message:</label>
          <textarea
            className="form-control"
            rows="4"
            value={whatsAppMessage}
            onChange={(e) => setWhatsAppMessage(e.target.value)}
            placeholder="Type your message here..."
          ></textarea>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-secondary mx-2"
            onClick={handleCloseWhatsAppModal}
          >
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSendWhatsApp}>
            Send on WhatsApp
          </button>
        </div>
      </ReactModal>
    </div>
  )
}

export default MobileUsers
